export default __webpack_public_path__ + "img/back4-ec4d0be3.png";